export const SCHEDULING_GROUPS_ACTIONS = {
  loadSchedulingGroups: 'LOAD_SCHEDULING_GROUPS',
};

export const SCHEDULING_GROUPS_REQUEST_ACTIONS = {
  getSchedulingGroupsSuccess: 'GET_SCHEDULING_GROUPS_SUCCEEDED',
  getSchedulingGroupsFailure: 'GET_SCHEDULING_GROUPS_FAILED',
};
